// Header.js (updated with navigation to login/signup pages)
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

function Header({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleScrollToSection = (sectionId) => {
    // Check if we're already on the home page
    if (location.pathname === '/') {
      // On home page, scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      // Not on home page, navigate to home page first
      navigate('/');
      
      // Wait for navigation and then scroll to section
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100); // Small delay to allow page load
    }
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleSignupClick = () => {
    navigate('/signup');
  };

  return (
    <header className="header">
      <div className="header-left">
        <h1 
          className="logo" 
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        >
          PDFraider
        </h1>
        <span className="version-badge">v1.0 Beta</span>
      </div>
      
      <nav className="header-center">
        <button 
          onClick={() => handleScrollToSection('features')} 
          className="nav-link"
          aria-label="Scroll to Features section"
        >
          Features
        </button>
        <button 
          onClick={() => handleScrollToSection('how-it-works')} 
          className="nav-link"
          aria-label="Scroll to How It Works section"
        >
          How It Works
        </button>
        
      </nav>
      
      <div className="header-right">
        {user ? (
          <div className="user-info">
            <div className="user-avatar">
              {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
            </div>
            <div className="user-details">
              <button onClick={onLogout} className="logout-button">
                Logout
              </button>
            </div>
          </div>
        ) : (
          <div className="auth-buttons">
            <button onClick={handleLoginClick} className="login-button">
              Login
            </button>
            <button onClick={handleSignupClick} className="signup-button">
              Sign Up
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;